import App from "./App";

import ProjectSelection from "./components/ProjectSelection";

import ForgetPassword from "./components/account/ForgetPassword/ForgetPassword";

import Register from "./components/account/Register/Register";
import RegistrationProjectChoice from "./components/account/Register/RegistrationProjectChoice";
import SetPassword from "./components/account/SetPassword/SetPassword";
import Unsubscribe from "./components/account/Unsubscribe/Unsubscribe";
import Verifyemail from "./components/account/Verifyemail/Verifyemail";

import ProtectedRoute from "./utils/guards/private-route.guard";
import { GoogleOAuthProvider } from "@react-oauth/google";

/////////////////////////////////////////////////////////////////////////////
import { lazy, useEffect } from "react";
import EstadaSuspense from "./components/EstadaSuspense";
import CreatePassword from "./components/account/CreatePassword/CreatePassword";
import { isDevelopmentEnvironment } from "./estada-config";
import { isUiModeProductAdmin } from "./uiMode";
import path from "path";

//////////////////////////////////////////////////////////////////////////////////////////////////
//
// Lazy loaded components
//
//////////////////////////////////////////////////////////////////////////////////////////////////

function LazyQuickstart() {
  return <EstadaSuspense Component={lazy(() => import("./components/Quickstart"))} />;
}

function LazySignalAnalysis() {
  return <EstadaSuspense Component={lazy(() => import("./components/SignalAnalysis"))} />;
}

function LazyUploadImageScreen() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/UploadImageScreen"))} />;
}

function LazyUploadProductdataScreen() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/UploadProductdataScreen"))} />;
}
function LazyProductConfigScreen() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/ConfigList"))} />;
}

function LazyProductListAdmin() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/ProductListAdmin"))} />;
}

function LazyProductWizard() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/ProductWizard"))} />;
}

function LazyScriptWizard() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/ScriptWizard"))} />;
}

function LazyVariantSelectionInterface() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/VariantSelectionInterface"))} />;
}

function LazySettingsScreen() {
  return <EstadaSuspense Component={lazy(() => import("./SettingsScreen"))} />;
}

function LazyPanel() {
  return <EstadaSuspense Component={lazy(() => import("./panel/Panel"))} />;
}

function LazyInstallation() {
  return <EstadaSuspense Component={lazy(() => import("./installation/Installation"))} />;
}

function LazySecondScreen() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/SecondScreen"))} />;
}

function RedirectUsersToCrm() {
  useEffect(() => {
    window.location.replace("http://crm.estada.de");
  }, []);

  return null;
}

function LazyPayment() {
  const PaymentScreenComponent = lazy(() => import("./Screens/Payment/PaymentScreen"));
  return (
    <EstadaSuspense
      Component={PaymentScreenComponent}
      props={{
        user: globalThis.state?.loggedInUser || { id: "", email: "", name: "" },
      }}
    />
  );
}

function LazySelfService() {
  return <EstadaSuspense Component={lazy(() => import("./Screens/Payment/SelfServiceScreen"))} />;
}

function ProductToolAccessGate(props: any) {
  return isUiModeProductAdmin() ? props.children : null;
}

function ProductToolRoute(props: any) {
  return isDevelopmentEnvironment() ? (
    props.children
  ) : (
    <ProtectedRoute>
      <ProductToolAccessGate>{props.children}</ProductToolAccessGate>
    </ProtectedRoute>
  );
}

///////////////////////////////////////////////////////////////////////////////////////////////////

export default function pd() {
  let url = window.location.href;

  const res = [
    {
      path: "/",
      element:
        url.indexOf("installation") >= 0 ? (
          <LazyInstallation />
        ) : url.indexOf("panel") >= 0 ? (
          <LazyPanel />
        ) : (
          <ProtectedRoute>
            <ProjectSelection />
          </ProtectedRoute>
        ),
    },
    {
      path: "/panel/*",
      element: <LazyPanel />,
    },
    {
      path: "/screen2",
      element: <LazySecondScreen />,
    },
    {
      path: "/app",
      element: (
        <ProtectedRoute>
          <App />
        </ProtectedRoute>
      ),
    },
    // {
    //   path: "/settings",
    //   element: (
    //     <ProtectedRoute>
    //       <LazySettingsScreen />
    //     </ProtectedRoute>
    //   ),
    // },

    {
      path: "/webhook", // to ceep track of payment ( mollie)
      element: (
        <ProtectedRoute>
          <div></div>
        </ProtectedRoute>
      ),
    },
    {
      path: "/quickstart",
      element: <LazyQuickstart />,
    },
    {
      path: "/signalAnalysis",
      element: <LazySignalAnalysis />,
    },

    {
      path: "/register",
      element: (
        <GoogleOAuthProvider
          // Old clientId="923522293386-90krmg3r02442obilbvcvior4lqtl63j.apps.googleusercontent.com">
          clientId="349503787284-ns3fmdpfbrr1q78gntv8pglppfpidd9r.apps.googleusercontent.com"
        >
          <Register />,
        </GoogleOAuthProvider>
      ),
    },
    {
      path: "/register-project",
      element: (
        <ProtectedRoute>
          <RegistrationProjectChoice />
        </ProtectedRoute>
      ),
    },
    {
      path: "/verify",
      element: <Verifyemail />,
    },
    { path: "/createPassword", element: <CreatePassword /> },
    {
      path: "/forget-password",
      element: <ForgetPassword />,
    },
    {
      path: "/reset-password",
      element: <SetPassword />,
    },
    {
      path: "/upload-productdata",
      element: (
        <ProductToolRoute>
          <LazyUploadProductdataScreen />
        </ProductToolRoute>
      ),
    },
    {
      path: "/upload-variantdata",
      element: (
        <ProductToolRoute>
          <LazyVariantSelectionInterface />
        </ProductToolRoute>
      ),
    },
    {
      path: "/list-productconfig",
      element: (
        <ProductToolRoute>
          <LazyProductConfigScreen />
        </ProductToolRoute>
      ),
    },
    {
      path: "/list-productadmin",
      element: (
        <ProductToolRoute>
          <LazyProductListAdmin />
        </ProductToolRoute>
      ),
    },
    {
      path: "/productwizard",
      element: (
        <ProductToolRoute>
          <LazyProductWizard />
        </ProductToolRoute>
      ),
    },
    {
      path: "/scriptwizard",
      element: (
        <ProductToolRoute>
          <LazyScriptWizard />
        </ProductToolRoute>
      ),
    },
    {
      path: "/upload-images",
      element: (
        <ProductToolRoute>
          <LazyUploadImageScreen />
        </ProductToolRoute>
      ),
    },
    {
      path: "/unsubscribe",
      element: <Unsubscribe />,
    },
    {
      path: "/installation",
      element: <LazyInstallation />,
    },
    {
      path: "/shop",
      element: <LazyPayment />,
    },
    {
      path: "/selfservice",
      element: <LazySelfService />,
    },
  ];

  res.push({
    path: "/users",
    element: <RedirectUsersToCrm />,
  });
  return res;
}
